/**
 * @packageDocumentation
 * This package is for use in Fabric examples and tests only. It's considered internal, so APIs
 * are subject to change without notice. (The only reason it uses api-extractor is so the types
 * can easily be added to the live example editor.)
 */

export * from './facepile';
export * from './listItems';
export * from './lorem';
export * from './people';
export * from './testImages';
export * from './range';
